/* eslint-disable simple-import-sort/imports */
import * as React from 'react';
import { useOpeningContext } from '@/contexts/opening-context';
import { HiringGoalsListContainer } from './hiring-goals-list-container';
import { StatusTabs } from './status-tabs';
import type { GoalStatus } from './types';

function HiringGoalsContent({
  hireATHiringGoalUrl,
  onClose,
}: {
  hireATHiringGoalUrl: string;
  onClose: () => void;
}) {
  const { hiringGoal } = useOpeningContext();
  const [activeTab, setActiveTab] = React.useState<GoalStatus>(
    hiringGoal?.is_current ? 'active' : 'past',
  );

  return (
    <div className="flex min-h-0 grow flex-col items-start gap-4 self-stretch p-5 ">
      <StatusTabs
        hireATHiringGoalUrl={hireATHiringGoalUrl}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      <div className="flex min-h-0 grow flex-col items-start gap-4 self-stretch overflow-y-auto">
        <HiringGoalsListContainer
          activeTab={activeTab}
          hireATHiringGoalUrl={hireATHiringGoalUrl}
          onClose={onClose}
        />
      </div>
    </div>
  );
}

export { HiringGoalsContent };
